import bowser from 'bowser';
export const isMsie = Boolean(window.msCrypto);
export const isSafari = Boolean(bowser.safari);
